import { RouteStep } from '../types';

export default function getCurrentStep(steps: RouteStep[]): RouteStep {
  const currentPath = window.location.pathname;

  return steps.find((step: RouteStep) => step.route === currentPath);
}
